<template>
  <el-dialog
    title="批量更新采集频率"
    :visible="visible"
    :append-to-body="true"
    width="750px"
    @close="close"
  >
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="选择设备" prop="deviceIds">
        <el-checkbox-group v-model="form.deviceIds">
          <el-checkbox
            v-for="(device,dIndex) in devices"
            :key="dIndex"
            :label="device.id"
          >{{device.holeName || device.name}}</el-checkbox>
        </el-checkbox-group>
        <div>
          <el-button type="text" v-if="!isAll" @click="toggleSelect">全部选中</el-button>
          <el-button type="text" v-else  @click="toggleSelect">全部取消</el-button>
        </div>
      </el-form-item>

      <el-form-item label="采集频率" prop="interval">
        <el-input-number :step="5" :min="0" placeholder="周期" v-model="form.interval">
        </el-input-number>
        分钟
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getProjectDevs, barchUpdateInterval } from '@/api';
import menus from '@/utils/menus';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      visible: false,
      devices: [],
      form: {
        id: '',
        departmentId: 0,
        deviceIds: [],
        interval: 0,
      },
      rules: {
        deviceIds: [
          {
            type: 'array',
            required: true,
            message: '请选择设备',
            trigger: 'blur',
          },
        ],
        interval: [{ required: true, message: '采集频率必填', trigger: 'blur' }],
      },
      menus,
    };
  },
  computed: {
    ...mapState('project', ['currentProject']),
    ...mapState('menu', ['activeMenu']),
    // ...mapState('device', ['deviceTypes']),
    isAll() {
      if (this.form.deviceIds.length === this.devices.length) {
        return true;
      }
      return false;
    },
    // formatData() {
    //   return this.deviceTypes.map((type) => {
    //     const devices = this.devices.filter(item => item.type === type);
    //     return { type, devices };
    //   });
    // },
  },
  methods: {
    async init(branchId = null, departmentId = null) {
      if (!branchId && !departmentId) {
        this.$message.error('请先选择分组后继续');
        return;
      }
      const { id } = this.currentProject;
      if (!this.activeMenu) {
        this.$message.error('请先选择设备类型后继续');
        return;
      }
      const type = this.activeMenu.id;
      getProjectDevs({
        id,
        type,
        size: 10000,
        page: 1,
        deviceNamePattern: '',
      }).then((res) => {
        let { devices } = res.data;
        if (devices.length) {
          devices = devices.filter(item => (departmentId
            ? item.BranchId === branchId && item.DepartmentId === departmentId
            : item.BranchId === branchId));
          this.devices.push(...devices);
        }
      });
    },
    show(branchId, departmentId = 0) {
      this.form.id = branchId;
      this.form.departmentId = departmentId || 0;
      this.init(branchId, departmentId);
      this.visible = true;
    },
    cancel() {
      this.form = {
        id: '',
        deviceIds: [],
        interval: '',
      };
    },
    close() {
      this.cancel();
      this.devices = [];
      this.visible = false;
    },
    submit() {
      this.$refs.form.validate((valued) => {
        if (!valued) return;
        const { id, deviceIds, interval } = this.form;
        barchUpdateInterval({
          id,
          deviceIds,
          interval: interval * 60,
        }).then((res) => {
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.close();
          } else {
            this.$message.error(res.data.msg);
            this.close();
          }
        });
      });
    },
    toggleSelect() {
      if (this.isAll) {
        Object.assign(this.form, { deviceIds: [] });
      } else {
        Object.assign(this.form, { deviceIds: this.devices.map(device => device.id) });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 12px;
}
</style>
